var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-2 order-cell",attrs:{"id":("order-" + _vm.order)}},[_vm._t("actions"),_c('span',[_vm._v(" "+_vm._s(_vm.order)+" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }